export default {
  equipment: {
    studyMachine: 'Learning Tablet',
    deliveryCreation: 'Create Shipment',
    deliveryDetail: 'Shipment Details',
    childrenDevice: 'Student Demo Device',
    barterManage: 'Exchange Management',
    takeDelivery: 'Warehouse Pickup',
    prototypeManagement: 'Demo Device Management',
    deviceSN: 'Device SN',
    deviceName: 'Device Name',
    agent: 'Master Franchisee',
    createTime: 'Created Time',
    operation: 'Actions',
    detail: 'Details',
    cancel: 'Cancel',
    confirm: 'Confirm',
    remark: 'Notes',
    yes: 'Yes',
    no: 'No',
    latest: 'Latest',
    assignDistributor: 'Assign Franchisee',
    assignCounter: 'Assign Counter',
    batchModifyAgent: 'Bulk Update Master Franchisee',
    modifyAgent: 'Update Master Franchisee',
    changeBindPhone: 'Update Bound Phone Number',
    logisticsDetail: 'Logistics Details',
    companyName: 'Company Name',
    pleaseSelectCompany: 'Select Company',
    query: 'Search',
    studyMachineRemark: 'Learning Tablet Notes',
    machineAccountCode: 'Learning Tablet Account ID',
    machineAccount: 'Learning Tablet Account',
    originalAgentId: 'Original Master Franchisee ID',
    originalAgentName: 'Original Master Franchisee Name',
    newAgentId: 'New Master Franchisee ID',
    newAgentName: 'New Master Franchisee Name',
    pleaseFillNewAgentId: 'Enter New Master Franchisee ID',
    pleaseFillPurchaseOrder: 'Enter Purchase Order Number',
    pleaseSelect: 'Please select',
    isMoveAccount: 'Transfer Account',
    batchAssignDistributor: 'Bulk Assign Sales Reps',
    assignTo: 'Assign to:',
    pleaseSelectDistributor: 'Select Sales Rep',
    assignToCounter: 'Assign to:',
    pleaseSelectCounter: 'Select counter',
    pleaseSelectMachine: 'Select Learning Tablet',
    agentIdSameTip: 'The new and original Master Franchisee IDs cannot be the same',
    sendCode: 'Send Verification Code',
    resend: 'Resend',
    secondsResend: 'Resend in {n} seconds',
    secondsResendEn: '{n}s',
    verificationCode: 'Verification Code',
    originalPhone: 'Original Phone Number',
    pleaseFillOriginalPhone: 'Enter Original Phone Number',
    pleaseFillNewPhone: 'Enter New Phone Number',
    verifyCode: 'Verify Code',
    pleaseFillVerificationCode: 'Enter Verification Code',
    nextStep: 'Next',
    bindSuccess: 'Phone number updated successfully',
    bindFail: 'Failed to update phone number',
    assignSuccess: 'Assigned successfully',
    assignFail: 'Assignment failed',
    modifySuccess: 'Updated successfully',
    modifyFail: 'Update failed',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancellation failed',
    verifySuccess: 'Verification code sent successfully',
    verifyFail: 'Failed to send verification code',
    submitFail: 'Submission failed',
    pleaseSelectPerson: 'Select Assignee',
    newLading: 'Create Delivery Order',
    prepayFreight: 'Prepaid Shipping Fee',
    cancelShipment: 'Cancel Shipment',
    confirmCancelShipment: 'Are you sure you want to cancel this shipment?',
    confirmCancelShipmentEn: 'Are you sure you want to cancel this delivery order?',
    ladingNo: 'Delivery Order Number',
    ladingNoLabel: 'Lading No.:',
    warehouse: 'Warehouse',
    warehouseOrderNo: 'Cloud Warehouse Order Number',
    submitTime: 'Submitted Time',
    sendStatus: 'Shipment Status',
    sendStatusCol: 'Send Status',
    prepaidFreight: 'Prepaid Freight',
    extractNum: 'Pickup Quantity',
    sendNum: 'Shipped Quantity',
    pleaseEnterLadingNo: 'Enter Delivery Order Number',
    pleaseSelectProductType: 'Select Product Type',
    pleaseSelectWarehouse: 'Select Warehouse',
    pleaseSelectSendStatus: 'Select Shipment Status',
    pleaseEnterWarehouseOrderNo: 'Enter Cloud Warehouse Order Number',
    addApply: '+ New Application',
    modify: 'Modify',
    audit: 'Review',
    childDeviceExport: 'Export Student Demo Device List',
    applyNo: 'Application Number',
    agentId: 'Master Franchisee ID',
    agentName: 'Master Franchisee Name',
    teacherName: 'Teacher Name',
    teacherPhone: 'Teacher Phone Number',
    childName: 'Child Name',
    teacherCertNo: 'Teacher Certification Number',
    auditStatus: 'Status',
    createByName: 'Created By',
    creator: 'Creator',
    auditTime: 'Review Time',
    auditor: 'Auditor',
    auditBy: 'Reviewed By',
    auditRemark: 'Review Notes',
    regionAgentId: 'Regional Master Franchisee ID',
    regionAgentName: 'Regional Master Franchisee Name',
    orderNo: 'Order Number',
    pleaseEnterApplyNo: 'Enter Application Number',
    pleaseEnterTeacherName: 'Enter Teacher Name',
    pleaseEnterTeacherPhone: 'Enter Teacher Phone Number',
    pleaseEnterTeacherCertNo: 'Enter Teacher Certification Number',
    pleaseSelectStatus: 'Select Status',
    pleaseEnterOrderNo: 'Enter Order Number',
    searchByDeviceSN: 'Search by Device SN',
    deviceSNCol: 'Device SN',
    pendingAudit: 'Pending Review',
    auditPassed: 'Approved',
    auditRejected: 'Rejected',
    auditReject: 'Return for Revision',
    applyAgent: 'Apply for Master Franchisee',
    regionAgent: 'Reviewing Regional Master Franchisee',
    applyRemarkLabel: 'Application Remark',
    createTimeLabel: 'Created Time',
    teacherCertMaterial: 'Teacher Certification and ID Documents',
    commitment: 'Commitment Letter',
    auditResult: 'Review Result',
    pleaseEnterApplyRemark: 'Enter Application Remark',
    pleaseEnterAuditRemark: 'Enter Review Remark',
    pleaseSelectAuditResult: 'Select Review Result',
    clickUploadImage: 'Upload Image',
    previewFile: 'Preview File',
    deleteFile: 'Delete File',
    pleaseUploadFile: 'Upload File',
    pleaseEnterChildName: 'Enter Child Name',
    batchNo: 'Batch Number',
    pleaseEnterBatchNo: 'Enter Batch Number',
    pleaseEnterDeviceSN: 'Enter Device SN Code',
    pleaseEnterProductName: 'Enter Product Name',
    receiveInfo: 'Shipping Information',
    pleaseEnterNamePhoneAddress: 'Enter Name / Phone / Address',
    dispatchDate: 'Shipment Date',
    expressCompany: 'Carrier',
    pleaseEnterExpressCompany: 'Enter Carrier',
    pleaseEnterExpressNo: 'Enter Tracking Number',
    logisticsStatus: 'Shipping Status',
    receiveBy: 'Recipient Name',
    receiveMobile: 'Recipient Phone Number',
    receiveAddressLabel: 'Shipping Address:',
    orderQuantityLabel: 'Order Quantity:',
    deliveredQuantityLabel: 'Shipped Quantity:',
    manufacturerLabel: 'Manufacturer:',
    provinceCityLabelShort: 'State / City:',
    batchNoLabel: 'Batch Number:',
    snCodeLabel: 'Device SN Code:',
    deviceInfoLabel: 'Device Information:',
    pleaseFillExpressNo: 'Enter tracking no.',
    pleaseFillBatchNo: 'Enter batch no.',
    pleaseFillSN: 'Enter SN code',
    pleaseSelectDeviceInfo: 'Select device info',
    shipmentExport: 'Shipment Export',
    shipmentImport: 'Shipment Import',
    deliver: 'Deliver',
    batchImport: 'Batch Import',
    uploadDoc: 'Upload Doc',
    dataValidate: 'Data Validate',
    importData: 'Import Data',
    complete: 'Complete',
    step1Tip1: '1. Do not change header names and purchase order info in template',
    step1Tip2: '2. For multiple devices per order, copy purchase order info, one row per device',
    step1Tip3: '3. Purchase ID and order no. are unique identifiers',
    step1Tip4: '4. Import file should not exceed 1000 rows',
    step1Title: 'Select file and start import',
    dragOrClick: 'Drag file here or',
    clickUpload: 'click to upload',
    dataValidating: 'Validating data, please wait',
    dataRetrieved: 'Validation complete, total',
    orderInfo: 'order(s)',
    errorInfo: 'Error(s)',
    errorInfoTip: ', please correct and retry',
    errorFileDownload: 'Download file for error details',
    errorFileXls: 'Error Info.xls',
    importingData: 'Importing. You may close this page, import will continue.',
    importComplete: 'Import complete. Click to view',
    upload: 'Upload',
    importDetail: 'Import Detail',
    purchaseNo: 'Purchase No',
    pleaseEnterPurchaseNo: 'Enter purchase no',
    orderStatus: 'Order Status',
    pleaseSelectOrderStatus: 'Select order status',
    lastDispatchTime: 'Last Dispatch Time',
    buyNum: 'Purchase Qty',
    receiveNum: 'Dispatch Qty',
    onlyXlsXlsx: 'Only .xls and .xlsx Files Are Supported',
    confirmImport: 'Confirm Import',
    done: 'Done',
    warningDataError: 'Warning: there are still data errors',
    partialErrorTip: 'Some data has errors. Errors will not be imported if you confirm.',
    noValidData: 'No valid data to import',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    confirmSuccess: 'Confirmed successfully',
    confirmFail: 'Confirmation failed',
    campusId: 'Master Franchisee ID',
    purchaseId: 'Purchase ID',
    manufacturer: 'Manufacturer',
    orderCreateTime: 'Order Created Time',
    snCodePlaceholder: 'Enter device SN',
    productTypeLabel: 'Product Type',
    productTypePlaceholder: 'Select product type',
    productName: 'Product Name',
    pleaseSelectAgent: 'Please select agent',
    agentPlaceholder: 'Select Master Franchisee',
    accountStatusLabel: 'Account Status:',
    accountStatusPlaceholder: 'Select Account Status',
    notActivated: 'Not Activated',
    activated: 'Activated',
    frozen: 'Frozen',
    subscribed: 'Subscribed',
    activateDateLabel: 'Account Activation Date:',
    expressCompanyPlaceholder: 'Select Carrier',
    expressNoLabel: 'Tracking Number:',
    expressNoPlaceholder: 'Enter Tracking Number',
    logisticsStatusPlaceholder: 'Select logistics status',
    stockStatusLabel: 'Inventory Status:',
    stockStatusPlaceholder: 'Select Inventory Status',
    notOut: 'Not Shipped',
    out: 'Shipped',
    purchaseNoLabel: 'Purchase Order Number:',
    remarkPlaceholder: 'Remark',
    remarkLabel: 'Remarks:',
    sealStatus: 'Archived Status',
    accountStatus: 'Account Status',
    deviceStatus: 'Device Status',
    stockStatus: 'Inventory Status',
    deviceActivateTime: 'Device Activation Time',
    accountActivateTime: 'Account Activation Time',
    agentIdLabelForm: 'Master Franchisee ID:',
    agentNameLabelForm: 'Master Franchisee Name:',
    warehouseLabel: 'Warehouse:',
    receiverLabel: 'Receiver:',
    receiverPhoneLabel: 'Receiver Phone:',
    provinceCityLabel: 'Province/City/District:',
    receiverAddressLabel: 'Receiver Address:',
    pleaseEnterCampusAddress: 'Enter Learning Center Address',
    remarkLabelForm: 'Remark:',
    pleaseEnterRemark200: 'Enter remarks (up to 200 characters)',
    selectAddGoods: '+ Select Products',
    addGoods: 'Add Products',
    delete: 'Delete',
    submit: 'Submit',
    confirmDelete: 'Confirm to delete?',
    pleaseSelectWarehouseRule: 'Please select warehouse',
    pleaseEnterReceiverRule: 'Enter receiver name',
    phoneRequiredRule: 'Phone number is required',
    pleaseEnterValidPhone: 'Enter valid phone number',
    pleaseSelectProvinceCityRule: 'Select province/city/district',
    pleaseEnterReceiverAddress: 'Enter receiver address',
    deliveryProductName: 'Product Name',
    inventory: 'Inventory',
    warehouseAvailableStock: 'Warehouse Available Stock',
    tidanhao: 'Pickup No.',
    createBy: 'Creator:',
    goodsInfo: 'Goods Info',
    logisticsInfo: 'Logistics Info',
    dispatchDateLabel: 'Dispatch Date',
    expressCompanyLabel: 'Express Company',
    logisticsStatusLabel: 'Logistics Status',
    deleteSuccess: 'Deleted successfully!',
    pleaseSelectWarehouseFirst: 'Please select warehouse first',
    receiverAddressMin8: 'Receiver address must be at least 8 Chinese characters',
    pleaseSelectGoodsFirst: 'Please select goods first',
    extractNumExceedInventory: 'Extract qty cannot exceed warehouse available stock',
    addBarter: '+ Add Exchange',
    payment: 'Payment',
    more: 'More',
    cancelConfirm: 'Cancel Confirmation',
    shipInProductName: 'Ship In Product:',
    shipInSwapNum: 'Ship In Qty:',
    shipOutProductName: 'Ship Out Product:',
    shipOutSwapNum: 'Ship Out Qty:',
    barterPriceDiff: 'Barter Price Diff:',
    cancelBarterTip: 'Confirm to cancel? Once cancelled, this barter application will be void and cannot be restored. You may create a new one if needed.',
    tip: 'Tip',
    paymentDeductionTip: 'This payment will deduct:',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryVoucherAccount: 'Delivery Voucher Account',
    gotIt: 'Got it',
    paySuccessAmount: 'Payment of ${money} was successful',
    payFailAmount: 'Payment of ${money} was not successful',
    paySuccess: 'Payment Success',
    payFail: 'Payment Failed',
    paymentFail: 'Payment failed',
    paymentSuccess: 'Payment successful',
    barterStatus: 'Exchange Status',
    priceDiffAmount: 'Price Difference Amount',
    paidAmount: 'Amount Paid',
    payStatus: 'Pay Status',
    applyAgentId: 'Apply Agent ID',
    applyAgentName: 'Apply Agent Name',
    shipOutProductNameCol: 'Outgoing Product Name',
    shipOutSwapNumCol: 'Outgoing Quantity',
    barterOrderNoCol: 'Barter Order No.',
    productLevel: 'Product Level',
    shipOutSendStatus: 'Outgoing Shipping Status',
    shipOutSendStatusLabel: 'Ship Out Status',
    swapAgentId: 'Exchange Master Franchisee ID',
    swapAgentName: 'Exchange Master Franchisee Name',
    shipInProductNameCol: 'Incoming Product Name',
    shipInSwapNumCol: 'Incoming Quantity',
    shipInSendStatus: 'Incoming Shipping Status',
    shipInSendStatusLabel: 'Ship In Status',
    barterOrderNo: 'Barter Order No.',
    pleaseEnterBarterOrderNo: 'Enter barter order no.',
    barterStatusLabel: 'Barter Status:',
    pleaseSelectBarterStatus: 'Select barter status',
    shipOutSendStatusPlaceholder: 'Outgoing product shipping status',
    shipInSendStatusPlaceholder: 'Incoming product shipping status',
    applyWarehouse: 'Apply Warehouse',
    pleaseSelectApplyWarehouse: 'Select apply warehouse',
    swapWarehouse: 'Swap Warehouse',
    pleaseSelectSwapWarehouse: 'Select swap warehouse',
    warehouseOrderNoInput: 'Warehouse Outbound Order Number',
    pleaseEnterCloudWarehouseDispatchOrderNo: 'Enter cloud warehouse dispatch order no.',
    rangeSeparator: 'to',
    pleaseSelectPayStatus: 'Select pay status',
    voucherBonusAccount: 'Referral Bonus Account',
    childDeviceListExport: 'Child Device List Export',
    applyInfo: 'Application Information',
    swapInfo: 'Exchange Information',
    receiveWarehouse: 'Receiving Warehouse',
    pleaseSelectReceiveWarehouse: 'Select receiving warehouse',
    pleaseEnter: 'Please enter',
    detailAddress: 'Address:',
    pleaseEnterDetailAddress: 'Enter address',
    warehouseOrderNoLabel: 'Warehouse Order Number:',
    shipStatusLabel: 'Shipping Status:',
    barterLogisticsNoLabel: 'Logistics No.:',
    selectSwapOutProduct: '+ Select Outgoing Product',
    snCodeCol: 'SN Code',
    swapOutTotalAmount: 'Total Outgoing Amount:',
    swapAgentLabel: 'Exchange Master Franchisee:',
    pleaseSelectSwapAgent: 'Select swap agent',
    selectSwapInProduct: '+ Select Incoming Product',
    swapInTotalAmount: 'Total Incoming Amount:',
    selectSwapOutProductTitle: 'Select Outgoing Product',
    swapOutProductModel: 'Outgoing Product Model',
    pleaseSelectProductModel: 'Select product model',
    differentPriceCannotMerge: '**Products with different prices cannot be merged for swap**',
    pleaseEnterSnCode: 'Enter SN code',
    transferPending: 'Pending',
    transferSelected: 'Selected',
    selectSwapInProductTitle: 'Select Incoming Product',
    swapInProductModel: 'Incoming Product Model:',
    productSwapableQty: 'Available Quantity for Exchange:',
    swapQtyLabel: 'Exchange Quantity:',
    pleaseEnterQty: 'Enter quantity',
    swapOutProductModelLabel: 'Outgoing Product Model:',
    priceDiffAmountLabel: 'Price Difference Amount:',
    paidAmountLabel: 'Amount Paid:',
    barterOrderNoLabel: 'Exchange Order Number:',
    remarkLabelBarter: 'Remarks:',
    remarkPlaceholder200: 'Enter remark within 200 characters',
    auditRemarkLabelBarter: 'Review Remarks:',
    auditResultLabel: 'Review Result:',
    agree: 'Approve',
    reject: 'Reject',
    auditOpinionLabel: 'Review Comments:',
    auditOpinionPlaceholder: 'Enter audit opinion within 100 characters',
    pleaseEnterAuditOpinion: 'Enter review comments',
    yuan: '$',
    pleaseEnterReceiverType: 'Enter {type} receiver',
    pleaseEnterReceiverPhoneType: 'Enter {type} receiver phone',
    pleaseSelectProvinceCityType: 'Select {type} province/city/district',
    pleaseEnterDetailAddressType: 'Enter {type} detail address',
    warehouseSameTip: 'Swap in/out warehouses must be the same. For cloud warehouse, use same location!',
    priceDiffTip: 'The amount due must be less than the swap-out unit price and ≥ 0. Adjust swap quantities and save again.',
    headquarterSwapTip: 'For HQ swap "HQ repurchase product", price diff must be 0',
    pleaseSelectSwapOutFirst: 'Please select swap out product first',
    swapQtyMin1: 'Swap quantity cannot be less than 1',
    swapQtyExceedTotal: 'Swap quantity cannot exceed available in warehouse',
    pleaseFillComplete: 'Please fill in complete info',
    warehouseChangeSwapOutTip: 'Warehouse change will clear all selected swap out products. Continue?',
    warehouseChangeSwapInTip: 'Warehouse change will clear all selected swap in products. Continue?',
    swapAgentChangeTip: 'Swap agent change will clear all selected swap in products. Continue?',
    applyParty: 'Apply Party',
    swapParty: 'Swap Party',
    operationSuccess: 'Operation Success',
    pleaseSelectDeviceToSelected: 'Please select device to selected area!',
    differentModelCannotMerge: 'Different models or prices cannot be merged for exchange',
    pleaseSelectExchangeOut: 'Please select swap out product',
    pleaseSelectExchangeIn: 'Please select swap in product',
    applyShipWarehouse: 'Apply Ship Warehouse',
    swapShipWarehouse: 'Swap Ship Warehouse',
    applyReceiver: 'Apply Receiver',
    swapReceiver: 'Swap Receiver',
    shipOutExpressNo: 'Ship Out Express No.',
    shipInExpressNo: 'Ship In Express No.',
    shipOutProductShip: 'Ship Out Product',
    shipInProductShip: 'Ship In Product',
    pleaseEnterFullExpressNo: 'Please enter complete express no.',
    shipSuccess: 'Shipment Success',
    pleaseEnterProductExpressNo: 'Please enter product express no.',
    shipIn: 'Inbound',
    shipOut: 'Outbound',
    receiveConfirmTitle: 'Delivery Confirmation',
    receiveConfirmCheck: 'Receive confirm: model, qty, SN code match',
    refuseAccept: 'Refuse:',
    pleaseEnterRefuseReason: 'Enter refuse reason',
    receiveConfirmTip: 'Once confirmed, swap product SN will transfer to swap party and cannot be returned!',
    pleaseCheckVerify: 'Please check verification item!',
    shipInOutExpressNo: 'Product Express No.:',
    shipInOutStatus: 'Product Ship Status:',
    warehouseShipOrderNo: 'Warehouse Ship Order No.:',
    payTitle: 'Payment',
    freightAmountLabel: 'Shipping Fee',
    relatedAgent: 'Related Master Franchisee',
    deliveryVoucherLabel: 'Delivery Voucher Account',
    accountBalance: 'Account Balance',
    relatedAgentBalance: 'Related Master Franchisee Balance',
    availableAmount: 'Available Amount',
    remainingPayAmount: 'Remaining Payment Amount',
    payMethod: 'Pay Method',
    bankTransfer: 'Bank Transfer',
    transferAmount: 'Transfer Amount',
    payTimeLabel: 'Pay Time',
    payTimeRequired: 'Pay time is required',
    pleaseSelectPayTime: 'Select pay time',
    paySerialNo: 'Payment Reference Number',
    pleaseEnterPaySerialNo: 'Enter payment reference number',
    payVoucher: 'Payment Proof',
    payVoucherRequired: 'Pay voucher is required',
    payVoucherTip: 'Support jpg/png, max 1080x1920, size under 5MB',
    credentialInstance: 'Voucher Example',
    payRemark: 'Payment Remarks',
    pleaseEnterPayRemark: 'Enter payment remarks',
    bankAccount: 'Bank Account',
    bankName: 'Bank Name',
    buyNumLabel: 'Buy Qty',
    orderAmountLabel: 'Order Amount',
    paidAmountReal: 'Actual Payment Amount',
    freightPlan: 'Freight Plan',
    plan1FreightCollect: 'Option 1: Freight Collect',
    plan1FreightTip: '(Pay to courier on delivery, amount may vary ~20%)',
    plan2FreightPrepay: 'Option 2: Prepaid Shipping',
    plan2FreightTip: '(Original {amount} yuan, pay with order, HQ handles disputes)',
    chargeItem: 'Charge Item',
    unitPrice: 'Unit Price',
    quantity: 'Qty',
    amount: 'Amount',
    discount: 'Discount',
    amountAfterDiscount: 'Amount After Discount',
    freightOrderTip: 'Order qty < 10, default freight collect. Prepay option for discount. Note:',
    freightRule1: '1. Collect discount per JD warehouse agreement, currently 65% off;',
    freightRule2: '2. Prepay optional; if declined, pay courier on delivery per their terms;',
    freightRule3: '3. If order merged and meets free shipping (≥10 units), prepaid freight refunded;',
    payFreightCollect: 'Pay (Freight Collect)',
    payFreightPrepay: 'Pay (Prepaid Shipping)',
    pleaseDoNotOperateTooFrequently: 'Please do not operate too frequently',
    qrCodeGenerating: 'QR code generating...',
    scanWithAlipay: 'Scan with Alipay',
    scanWithWechat: 'Scan with WeChat',
    qrCodeUrlInvalid: 'QR code URL invalid',
    payAmountYuan: 'Pay {symbol}{amount}',
    unitTai: 'Units',
    markPrototype: 'Mark as Demo Device',
    prototypeAccountRenewal: 'Demo Device Account Renewal',
    accountPhoneRebind: 'Rebind Account Phone',
    unmarkPrototype: 'Unmark Demo Device',
    prototypeMark: 'Demo Device Mark',
    productModel: 'Product model',
    prototypeType: 'Demo Device Type',
    pleaseSelectPrototypeType: 'Please select prototype type',
    shippedPrototypeCount: 'Shipped prototype count',
    markedPrototypeCount: 'Marked-as-prototype count',
    markablePrototypeCount: 'Prototype(s) available to mark',
    save: 'Save',
    prototypeRenewalApply: 'Demo Device Account Renewal Request',
    prototypeSN: 'Demo Device SN Code',
    currentCertArea: 'Current certified region',
    accountActiveTime: 'Account activation time',
    accountValidPeriod: 'Account validity period',
    renew: 'Renew',
    machineAccountNo: 'Learning Tablet Account Number',
    confirmUnmarkPrototype: 'Remove prototype marking?',
    searchStudent: 'Search Student',
    accountActiveDate: 'Account activation date',
    pleaseEnterMachineAccount: 'Enter learning tablet account',
    pleaseEnterStudentAccountName: 'Enter student account or name',
    accountValidDate: 'Account valid until',
    studentAccount: 'Student Account',
    studentName: 'Student Name',
    campusName: 'Learning Center Name',
    schoolId: 'Learning Center ID',
    schoolName: 'Learning Center Name',
    prototypeNote1: '1. After marking as prototype, it cannot be changed.',
    prototypeNote2: '2. Prototypes cannot be sold; for trial and display only.',
    prototypeNote3: '3. One study account per prototype. If multiple accounts exist, pick one to keep; others will be unbound.',
    prototypeMarkOnceTip: 'After marking as prototype, it cannot be changed.',
    pleaseVerifyDeviceSN: 'Verify device SN first',
    pleaseSelectStudent: 'Please select a student',
    markSuccess: 'Marked successfully',
    renewSuccess: 'Renewal succeeded',
    renewFail: 'Renewal failed',
    pleaseEnterNewPhone: 'Enter new mobile number',
    pleaseEnterVerifyCode: 'Enter verification code',
    rebindSuccess: 'Rebinding successful',
    rebindFail: 'Rebinding failed',
    add: 'Add',
    jdSendParamExport: 'JD Warehouse Shipping Parameter Export',
    jdSend: 'JD Warehouse Shipping',
    printDeliveryOrder: 'Print Delivery Order',
    adjustDispatchType: 'Adjust Shipping Method',
    adjustDispatchTypeTo: 'Change shipping method to:',
    pleaseSelectDispatchType: 'Select shipping method',
    confirmCancel: 'Confirm cancel?',
    regionAgentLabel: 'Regional Master Franchisee',
    receiverInfo: 'Recipient Information',
    pleaseEnterReceiverInfo: 'Enter recipient information',
    tmallOrderNo: 'Tmall Order Number',
    pleaseEnterTmallOrderNo: 'Enter Tmall order number',
    confirmBy: 'Confirm By',
    shipRegionAgentId: 'Regional Master Franchisee ID',
    shipRegionAgentName: 'Regional Master Franchisee Name',
    saleShipmentExport: 'Sales Shipment Export',
    shipWarehouse: 'Shipping Warehouse',
    pleaseSelectJdCloudShipWarehouse: 'Please select JD cloud ship warehouse',
    pleaseSelectShipWarehouse: 'Select shipping warehouse',
    jdProductName: 'JD Product Name',
    pleaseEnterJdProductName: 'Enter JD product name',
    waitSendNumCol: 'Pending Shipment Quantity',
    agentWarehouseName: 'Master Franchisee Receiving Warehouse',
    provinceCity: 'Province/City/District',
    receiverAddress: 'Recipient Address',
    shipWarehouseCol: 'Shipping Warehouse',
    relatedOrder: 'Related Order',
    pleaseEnterRelatedOrder: 'Enter related order',
    sendTime: 'Shipping Time',
    sentNum: 'Shipped Quantity',
    logisticsCompany: 'Logistics Company',
    logisticsNo: 'Tracking Number',
    pleaseEnterLogisticsNo: 'Enter tracking number',
    orderDeliveryStatus: 'Order Shipping Status',
    pleaseSelectOrderDeliveryStatus: 'Select order shipping status',
    pleaseEnterShipmentNo: 'Enter shipment number',
    transferOrderNo: 'Transfer Order Number',
    expressNo: 'Tracking Number',
    shipStatus: 'Ship Status',
    pleaseSelectShipStatus: 'Select shipping status',
    cancelBy: 'Canceled By',
    cancelTime: 'Canceled Time',
    confirmCancelShip: 'Are you sure you want to cancel shipment?',
    pleaseEnterTransferOrderNo: 'Enter transfer order number',
    paramType: 'Parameter Type',
    paramValue: 'Parameter Value',
    condition: 'Condition',
    pleaseSelectProduct: 'Please select product',
    pleaseSelectParamType: 'Please select parameter type',
    pleaseSelectParamValue: 'Please select parameter value',
    pleaseEnterMinValue: 'Please enter minimum value',
    pleaseEnterMaxValue: 'Please enter maximum value',
    deliveryQty: 'Shipment quantity',
    unit: 'units',
    deleteConfig: 'Delete',
    confirmDeleteConfig: 'Are you sure you want to delete this configuration?',
    addJdSendParam: 'Add JD Warehouse Shipping Parameters',
    editJdSendParam: 'Edit JD Warehouse Shipping Parameters',
    agentLabel: 'Master Franchisee',
    productLabel: 'Product',
    mailPayMark: 'Shipping Payment Indicator',
    deleteSuccessMsg: 'Deleted successfully',
    deleteFailMsg: 'Delete failed',
    saveSuccessMsg: 'Saved successfully',
    saveFailMsg: 'Save failed',
    pleaseSelectDeliveryOrder: 'Please select delivery order',
    generateDeliveryOrderSuccess: 'Delivery order generated successfully!',
    adjustDispatchTypeSuccess: 'Shipping method updated successfully!',
    pleaseFillManualAllocationInfo: 'Please fill in complete manual allocation info before saving',
    pleaseSelectPaymentMethod: 'Please select payment method for remaining amount',
    insufficientBalanceRecharge: 'Insufficient account balance. Please recharge first.',
    snDuplicateCheck: 'Duplicate SN code detected. Please check and confirm.',
    currentSnExists: 'This SN code already exists.',
    pleaseEnterDeviceInfo: 'Please enter device info',
    order: 'Tmall Order Number:',
    ship: 'Partial Shipment',
    time: 'Account Activation Time',
    danhao: 'Tracking Number',
    device: 'Device SN Code:',
    already: 'Applied',
    name: 'Sub-Franchisee Name',
    info: 'Recipient Information:',
    chudanhao: 'Warehouse Outbound Order Number',
    consignee: 'Recipient',
    shouji: 'Recipient Phone',
    address: 'Recipient Address',
    mobile: 'Enter name / phone / address',
    queren: 'Confirm Receipt',
    pending: 'Pending Application',
    purchase: 'Purchase Order Number',
    num: 'Shipment Quantity',
    dianhua: 'Recipient Phone',
    activate: 'Activated',
    not: 'Not Outbound',
    jidailiqu: 'Sub-Franchisee Region',
    dinghao: 'Subscription Card Number',
    qing: 'Not Eligible',
    buyTime: 'Purchase Date',
    validTime: 'Valid Date',
    headOfficeDispatchOrderStatus6068002: 'Confirmed',
    headOfficeDispatchOrderStatus6068010: 'Shipping',
    headOfficeDispatchOrderStatus6068007: 'Shipped',
    headOfficeDispatchOrderStatus6068009: 'Partially Shipped',
    headOfficeDispatchOrderStatus6068008: 'Receipt Confirmed',
    headOfficeDispatchOrderStatus6068013: 'Rejected, Pending Reshipment',
    headOfficeTransferColOrderQty: 'Order Quantity',
    headOfficeTransferColOrderAmount: 'Order Amount',
    headOfficeTransferColShipOrderNo: 'Delivery Order Number',
    areaConsignmentShipStatusValid: 'Valid',
    areaConsignmentShipStatusCancelled: 'Canceled',
  }
}
